import { useEffect, useState } from "react";
import { saveUserAttributes } from "../api/user-attributes.api";
import { COOKIE_KEY, IFRAME_MESSAGES } from "../lib/constants";
import { env } from "../lib/env";
import { useGlobalStore } from "../store/globalStore";

type UseQueryParams = {
  projectId: string;
  orgId: string;
  apiKey: string;
  conversationMedium: string;
};

const useQueryParams = ({
  projectId,
  orgId,
  apiKey,
  conversationMedium,
}: UseQueryParams) => {
  const { conversationId } = useGlobalStore((state) => state);
  const [hasRunOnce, setHasRunOnce] = useState(false);

  const shouldTrigger = Boolean(conversationId && projectId && orgId && apiKey);

  useEffect(() => {
    if (hasRunOnce || !shouldTrigger) return;

    const handleMessage = async (event: MessageEvent) => {
      const { type, queryParams } = event.data ?? {};

      const payload = queryParams;
      if (type !== IFRAME_MESSAGES.setQueryParams) return;
      if (!queryParams || Object.keys(queryParams).length === 0) return;
      const { cookieList } = event.data;
      const tokenKey =
        cookieList[`${COOKIE_KEY.tokenKey}-${orgId}-${apiKey}`] ?? "";

      const tokenValue = conversationMedium
        ? cookieList[`${tokenKey}-${conversationMedium}`]
        : (cookieList[tokenKey] ?? "");
      try {
        await saveUserAttributes({
          userAttributes: payload,
          conversationIdentifier: conversationId,
          orgId,
          projectId,
          jwtToken: tokenValue,
          saveAsJson: true,
          keyName: "web_url_parameters",
        });
      } catch (error) {
        if (env.isDev) {
          console.error("[Failed to save user attributes]: ", error);
        }
      } finally {
        setHasRunOnce(true);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [
    hasRunOnce,
    shouldTrigger,
    conversationId,
    projectId,
    orgId,
    apiKey,
    conversationMedium,
  ]);
};

export default useQueryParams;
